var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TextWithLinksStep',{attrs:{"title":_vm.$t('backstock.setup.trainTeam.title'),"sections":_vm.$t('backstock.setup.trainTeam.sections')},scopedSlots:_vm._u([{key:"extension",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t("backstock.setup.trainTeam.extensionText"))+" ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }